import React from 'react';
import styled from '@emotion/styled';
import { Download } from 'lucide-react';

const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.75rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  background: #4a4a4a;
  color: #e0e0e0;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  justify-content: center;
  
  &:hover {
    background: #555;
  }
  
  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
`;

const ExportButtonComponent = ({ onClick, disabled = false, children, icon: Icon = Download, ...props }) => {
  return (
    <ExportButton onClick={onClick} disabled={disabled} {...props}>
      <Icon size={14} />
      {children}
    </ExportButton>
  );
};

export default ExportButtonComponent;

